<template>
  <main>
    <Transition name="fade">
      <div v-if="page">
        <HomeHeader :content="page.data.header as HomeHeader"/>
        <PageSections :sections="page.data.sections"/>
      </div>
    </Transition>
  </main>
</template>

<script lang="ts">
import {ViewDataMixin} from '@/views/mixins'
import {HomeHeader, PageSections} from '@/components/sections'
import {usePageStore} from '@/stores'

export default {
  name: 'HomePage',
  mixins: [ViewDataMixin],
  components: {HomeHeader, PageSections},
  data() {
    return {
      page: null as Page | null
    }
  },
  methods: {
    async init() {
      const page = await usePageStore().get('home')

      if (!page) {
        return await this.$router.push({name: this.$routes.NOT_FOUND})
      }

      this.page = page
    }
  }
}
</script>